export class JanglCheckboxController {
    $onInit() {
      if (!this.name) throw new Error('Checkboxes must have a name attribute');
      if (!this.hasOwnProperty('model')) throw new Error(this.name + ': model attribute must be set.');

      this.model = this.model || false;

      this._errorMessages = angular.copy(this.errorMessages) || [];

      if (!this._errorMessages.find((item) => { return (item.type == 'required')})) {
          this._errorMessages.push({type: 'required', msg: 'You must check this box to proceed.'});
      }
    }
}
JanglCheckboxController.$inject = [];

export default JanglCheckboxController;


// WEBPACK FOOTER //
// ./app/jangl/jangl-checkbox/controller.js